module.exports = __webpack_public_path__ + "static/img/logo_kakaopay@3x.e6d5a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/logo_kakaopay@3x.png
// module id = Lq0c
// module chunks = 10